module.exports = __webpack_public_path__ + "static/media/MLGUI.6bfa9579.png";